import { ChangeEvent, useEffect, useRef, useState } from "react";
import { Autocomplete } from "@mui/material";

const DropdownAutocompleteField = ({
  id,
  name,
  onChange,
  value,
  className,
  style,
  errorFields,
  placeholder,
  options,
  getOptionLabel,
  renderInput,
  renderOption,
  isOptionEqualToValue,
}: {
  onChange: (value: ChangeEvent<HTMLInputElement>) => void;
  id: string;
  name: string;
  value: string;
  className?: string;
  style?: any;
  errorFields?: Record<string, boolean>;
  placeholder?: string;
  options: any[];
  getOptionLabel: (option: any) => string;
  renderInput?: (params: any) => JSX.Element;
  renderOption: (props: any, option: any) => JSX.Element;
  isOptionEqualToValue?: (option: any, value: any) => boolean;
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef: any = useRef();

  useEffect(() => {
    if (isFocused) {
      inputRef.current.focus();
    }
  }, [isFocused]);

  {
    /* <>      
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        cursor: "pointer",
        color: "#CECECE",
        ...(errorFields?.signature ? { borderColor: "red" } : {}),
      }}
      onClick={() => inputRef.current?.click()}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        {renderInput ? (
          renderInput({ inputRef, onFocus: () => setIsFocused(true) })
        ) : (
          <input
            ref={inputRef}
            type="text"
            hidden
            id={id}
            value={value}
            name={name}
            onChange={onChange}
            onFocus={() => setIsFocused(true)}
          />
        )}
      </div>
    </div>

    {inputRef.current?.value && (
      <Autocomplete
        id={id}
        options={options}
        getOptionLabel={getOptionLabel}
        value={value}
        onChange={onChange}
        renderInput={(params) => (
          <div ref={params.InputProps.ref}>
            {renderInput ? (
              renderInput({ inputRef, onFocus: () => setIsFocused(true) })
            ) : (
              <input
                {...params.inputProps}
                ref={inputRef}
                type="text"
                hidden
                id={id}
                value={value}
                name={name}
                onChange={onChange}
                onFocus={() => setIsFocused(true)}
              />
            )}
          </div>
        )}
        renderOption={renderOption}
        isOptionEqualToValue={(option, value) => option.id === value.id}
      />
    )}
  </> */
  }
  return (
    <Autocomplete
      id={id}
      options={options}
      getOptionLabel={(option) => option.name || ""}
      value={options.find((c) => c.id === Number(value)) || null}
      onChange={(_, newValue) => {
        onChange({
          target: {
            name: name,
            value: newValue ? newValue.id : "",
          },
        } as any);
      }}
      renderInput={(params) => (
        <div ref={params.InputProps.ref}>
          <input
            {...params.inputProps}
            className="standard_form_input"
            style={errorFields?.[name] ? { borderColor: "red" } : {}}
            placeholder={placeholder}
          />
        </div>
      )}
      renderOption={renderOption}
      isOptionEqualToValue={(option, value) => option.id === value.id}
    />
  );
};

export default DropdownAutocompleteField;
